export const INFO_MODAL_NAME = 'info';
export const INFO_MODAL_DEFAULT_TITLE = 'Информация';
